
import html2Canvas from 'html2canvas';
import { jsPDF } from 'jspdf';


export function html2pdf(dom, title = 'pdf') {
  if (typeof dom === 'string') {
    dom = document.querySelector(dom);
  }
  return html2Canvas(dom, {
    scale: 3,
    useCORS: true,
  }).then((canvas) => {
    const contentWidth = canvas.width;
    const contentHeight = canvas.height;
    const pageHeight = contentWidth / 592.28 * 841.89;
    let leftHeight = contentHeight;
    let position = 0;
    const imgWidth = 595.28;
    const imgHeight = 592.28 / contentWidth * contentHeight;
    const pageData = canvas.toDataURL('image/jpeg', 1.0);
    // eslint-disable-next-line new-cap
    const PDF = new jsPDF('', 'pt', 'a4');
    if (leftHeight < pageHeight) {
      PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
    } else {
      while (leftHeight > 0) {
        PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
        leftHeight -= pageHeight;
        position -= 841.89;
        if (leftHeight > 0) {
          PDF.addPage();
        }
      }
    }

    PDF.save(`${title}.pdf`);
  }).catch((e) => {
    if (e) console.log(e);
  });
}



// WEBPACK FOOTER //
// ./src/libs/pdf.js